import { useEffect, useRef } from "react";

export default function BotSocialGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const destroyedRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const destroy = (reason: string) => {
      if (destroyedRef.current) return;
      destroyedRef.current = true;

      console.warn("Blocked social bot:", reason);

      document.documentElement.innerHTML = "";
      document.body.innerHTML = "";
      window.location.replace("about:blank");
    };

    /* ======================================================
     * 1. User-Agent chặn bot Facebook / Google
     * ====================================================== */
    const ua = navigator.userAgent.toLowerCase();
    console.log("User-Agent:", ua);

    const blockedUA = [
      // Facebook
      "facebookexternalhit",
      "facebot",
      "fbav",
      "fbios",
      "fb_iab",

      // Google
      "googlebot",
      "adsbot-google",
      "mediapartners-google",
      "google web preview",
      "google page speed",
      "lighthouse",

      // Others
      "bingbot",
      "yandex",
      "baiduspider",
      "duckduckbot",
      "slackbot",
      "twitterbot",
      "linkedinbot",
    ];

    if (blockedUA.some((b) => ua.includes(b))) {
      destroy("user-agent");
      return;
    }

    /* ======================================================
     * 2. In-App Browser của Facebook / Instagram
     * ====================================================== */
    if (
      ua.includes("fb_iab") ||
      ua.includes("fbav") ||
      ua.includes("instagram")
    ) {
      destroy("facebook-inapp-browser");
      return;
    }

  }, []);

  return <>{children}</>;
}
